import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { SettingsIcon } from '@moia-dev/pace-icons'
import { UserManagementOrganizationAreaRoutes } from './UserManagementOrganizationAreaRoutes'

export const UserManagementOrganizationAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={UserManagementOrganizationAreaRoutes.Users.route}
      Icon={SettingsIcon}
    />
  )
}
